// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import { FaMoon, FaSearch } from "react-icons/fa";
// import { TfiShine } from "react-icons/tfi";
// import { useAppDispatch, useAppSelector } from "../../redux/ReduxType";
// import { toggle } from "../../redux/slice/themeSlice";
// import MovingMoneyRate from "../../services/ExchangeRate";
// // import AuthContext from "../../context/AuthProvider";
// import { CgProfile } from "react-icons/cg";
// // import { headerItems } from "../molecules/Header/HeaderList";
// import NewsCarossel from "../../services/NewsCarossel";
// // import { IUserState } from "../../redux/slice/user.slice";
// // import { BsBell } from "react-icons/bs";

// const Header = () => {
//   const auth = useAppSelector((state) => state.user) || {};
//   const isDark = useAppSelector((state) => state.theme.isDark);

//   const dispatch = useAppDispatch();
//   const [currentMenu, setCurrentMenu] = useState("/");

//   // menu section handler function
//   const handleSelectedMenu = (selection: string) => {
//     setCurrentMenu(selection);
//   };

//   // theme toggle handler function
//   const handleDark = () => {
//     dispatch(toggle());
//   };

//   return (
//     <div
//       className={`w-[100%] text-sm ${
//         isDark
//           ? "bg-darkBg transition-all duration-500 text-darkText"
//           : "bg-lightBg text-left"
//       } px-5 w-[100%] mx-auto shadow-md`}
//     >
//       <div className="navbar">
//         {/* left section */}
//         <div
//           onClick={() => {
//             handleSelectedMenu("/");
//           }}
//           className="navbar-start text-indigo-500"
//         >
//           <Link to="/" className="font-bold text-xl text-deepBg">
//             OOSH
//           </Link>
//         </div>

//         {/* middle section */}

//         <div className="navbar-center lg:flex text-md">
//           <label
//             className={`input ${
//               isDark ? "bg-deepLight text-deepBg" : "border-deepBg border-2"
//             } sm:flex hidden items-center gap-2 w-[600px] rounded-full`}
//           >
//             <FaSearch
//               className={`text-indigo-400 ${
//                 isDark ? "text-darkBg" : "text-[gray]"
//               }`}
//             />
//             <input
//               className="grow border-none outline-none"
//               placeholder="search"
//             />
//           </label>
//           <div
//             className={`swap swap-rotate px-10 ${
//               currentMenu === "notify" ? "text-indigo-500" : ""
//             } w-fit`}
//             onClick={handleDark}
//           >
//             {isDark ? (
//               <TfiShine className="w-4 h-4 fill-current" />
//             ) : (
//               <FaMoon className="w-4 h-4 fill-current" />
//             )}
//           </div>
//         </div>

//         {/* right section */}
//         <div className="navbar-end flex gap-2 items-center">
//           <div className="avatar">
//             <div className="w-6 rounded-full">
//               {auth?.avatar ? (
//                 <img src={auth?.avatar} alt="avatar" />
//               ) : (
//                 <CgProfile className="w-full h-full" />
//               )}
//             </div>
//           </div>
//           {auth?.fullname ? (
//             <Link to={`/profile/${auth._id}`} className="">
//               {auth.fullname.split(" ")[0]}
//             </Link>
//           ) : (
//             <Link to="/login" className="">
//               Login
//             </Link>
//           )}
//         </div>
//       </div>

//       {/* other products */}
//       <MovingMoneyRate isDark={isDark} />

//       {/* news carossel */}
//       <NewsCarossel isDark={isDark} />

//       {/* other products */}
//       {/* <div className="w-full overflow-hidden flex items-center justify-center gap-10 text-sm p-2">
//         {headerItems.map((eachItems, index) => {
//           return (
//             <Link
//               to={`/${eachItems.id}`}
//               key={eachItems.id}
//               className={`flex-shrink-0 ${
//                 isDark ? "text-deepText" : "text-left"
//               } hover:text-indigo-500`}
//             >
//               {eachItems.content}
//             </Link>
//           );
//         })}
//       </div> */}
//     </div>
//   );
// };

// export default Header;

// -------- version 2 ---------
import React, { ChangeEvent, FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { FaMoon, FaSearch } from "react-icons/fa";
import { TfiShine } from "react-icons/tfi";
import { useAppDispatch, useAppSelector } from "../../redux/ReduxType";
import { toggle } from "../../redux/slice/themeSlice";
import MovingMoneyRate from "../../services/ExchangeRate";
import { CgProfile } from "react-icons/cg";
import NewsCarossel from "../../services/NewsCarossel";
import CustomModal from "../modal/CustomModal";

const Header = () => {
  const auth = useAppSelector((state) => state.user) || {};
  const isDark = useAppSelector((state) => state.theme.isDark);
  const dispatch = useAppDispatch();
  const [currentMenu, setCurrentMenu] = useState("/");
  const [openModal, setOpenModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSelectedMenu = (selection: string) => {
    setCurrentMenu(selection);
  };

  const handleDark = () => {
    dispatch(toggle());
  };

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setOpenModal(true);
    setSearchQuery(e.target.value);
  };

  return (
    <header
      className={`w-full shadow-sm ${
        isDark ? "bg-darkBg text-white" : "bg-white text-gray-900"
      } transition-all duration-300`}
    >
      <div className="max-w-[1440px] mx-auto px-4 py-3 flex items-center justify-between">
        {/* Left Section */}
        <div onClick={() => handleSelectedMenu("/")} className="flex-shrink-0">
          <Link
            to="/"
            className="text-xl font-bold text-indigo-600 hover:text-indigo-700"
          >
            OOSH
          </Link>
        </div>

        {/* Middle Section */}
        <div className="flex items-center gap-4 flex-1 justify-center">
          <label
            className={`hidden sm:flex items-center gap-2 px-4 py-2 rounded-md text-sm max-w-md w-full ${
              isDark
                ? "bg-deepBg border-darkBg text-gray-200"
                : "bg-gray-100 border-gray-300 text-deepBg"
            } border shadow-sm focus-within:ring-2 focus-within:ring-indigo-500`}
          >
            <FaSearch
              className={`w-4 h-4 ${
                isDark ? "text-gray-400" : "text-gray-500"
              }`}
            />
            <input
              className="grow bg-transparent outline-none placeholder-gray-500 dark:placeholder-gray-400"
              placeholder="Search"
              onChange={handleSearchChange}
            />
          </label>
          <button
            onClick={handleDark}
            className={`p-2 rounded-full ${
              isDark
                ? "text-gray-300 hover:bg-gray-700 hover:text-white"
                : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            } transition-colors duration-200`}
            aria-label="Toggle theme"
          >
            {isDark ? (
              <TfiShine className="w-5 h-5" />
            ) : (
              <FaMoon className="w-5 h-5" />
            )}
          </button>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          <div className="avatar">
            <div className="w-8 h-8 rounded-full overflow-hidden">
              {auth?.avatar ? (
                <img src={auth?.avatar} alt="Profile avatar" />
              ) : (
                <CgProfile className="w-full h-full text-gray-500 dark:text-gray-400" />
              )}
            </div>
          </div>
          {auth?.fullname ? (
            <Link
              to={`/profile`}
              className="text-sm font-medium hover:text-indigo-600 dark:hover:text-indigo-400"
            >
              {auth.fullname.split(" ")[0]}
            </Link>
          ) : (
            <Link
              to="/login"
              className="text-sm font-medium hover:text-indigo-600 dark:hover:text-indigo-400"
            >
              Login
            </Link>
          )}
        </div>
      </div>

      {/* Additional Sections */}
      {/* <MovingMoneyRate isDark={isDark} />
      <NewsCarossel isDark={isDark} /> */}
      <CustomModal
        size="xl"
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <div>
          <h1>{searchQuery}</h1>
        </div>
      </CustomModal>
    </header>
  );
};

export default Header;
